'use strict';

const analyticsHelper = require('../../util/analyticsHelper');

const triggerViewPromotionEvent = () => {
    analyticsHelper.trackEvent('view_promotion');
}

const initViewPromotionEvent = () => {
    $(`
        .banner-slide.promotional-banner,
        .invoice-home .banner-container,
        .generate-invoice .banner-container,
        .download-invoice-card_banner
    `).on('click', triggerViewPromotionEvent);
}

module.exports = {
    initViewPromotionEvent: initViewPromotionEvent
}